export default __webpack_public_path__ + "static/media/clinician.64b0f91a.svg";